const Divider     = {
    Divider:     <svg
    xmlns="http://www.w3.org/2000/svg"
    width="512"
    height="512"
    enableBackground="new 0 0 512 512"
    viewBox="0 0 384 384"
  >
    <g fill="#eb0606">
      <path
        xmlns="http://www.w3.org/2000/svg"
        d="M0 384h384V0H0zM32 32h320v320H32zm0 0"
        data-original="#000000"
      ></path>
      <path
        xmlns="http://www.w3.org/2000/svg"
        d="M112 176h160v32H112zm0 0M176 112h32v32h-32zm0 0M176 240h32v32h-32zm0 0"
        data-original="#000000"
      ></path>
    </g>
  </svg>
 }
 
 
 export default Divider;
 